<div style="overflow-y: auto;position: relative; padding-bottom: 100px;overflow-x: hidden;">
  <div class="row">
    <div class="col-md-12 margin-top-16">
      <div class="sub-header">
        {{
        appConfig.getCustomLabelForMessageTag(messageTemplate.EventTag, (messageTemplate.EventTag + '_title' | translate
        :
        {
        ServiceFollowUpReminderMonths:
        partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService: partner.ReminderHoursBeforeService,
        WaitingDelayHours: partner.WaitingDelayHours, OtherServiceFollowUpReminderMonths:
        partner.OtherServiceFollowUpReminderMonths,
        PostServiceFollowUpDays: partner.PostServiceFollowUpDays
        }), false)
        }}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 margin-bottom-16">
      <div class="label bold">
        {{
        appConfig.getCustomLabelForMessageTag(messageTemplate.EventTag, (messageTemplate.EventTag + '_description' |
        translate : {
        ServiceFollowUpReminderMonths:
        partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService: partner.ReminderHoursBeforeService,
        WaitingDelayHours: partner.WaitingDelayHours, OtherServiceFollowUpReminderMonths:
        partner.OtherServiceFollowUpReminderMonths,
        PostServiceFollowUpDays: partner.PostServiceFollowUpDays
        }), true)
        }}
      </div>
    </div>
  </div>

  <div *ngIf="loading" style="margin-top: 32px;display: flex;justify-content: center;">
    <p-progressSpinner [style]="{ width: '40px', height: '40px' }" animationDuration=".5s">
    </p-progressSpinner>
  </div>

  <div *ngIf="!loading">
    <div class="info-container"
      *ngIf="whatsappConfiguredEnabled && messageTemplate.EventTag !== 'rentals.waiversigned'">
      <div class="category-header">{{'bikeshop.message_templates.whatsapp_header' | translate}}</div>
      <div class="category-info">{{'bikeshop.message_templates.whatsapp_info' | translate}}</div>


      <div class="row">
        <div class="col-md-6 col-lg-3 label">{{'bikeshop.message_templates.whatsapp_message_active' | translate}}:</div>
        <div class="col-md-6 col-lg-9">
          <p-inputSwitch [(ngModel)]="messageTemplate.WhatsappActive"></p-inputSwitch>
        </div>
      </div>

      <div *ngIf="messageTemplate.WhatsappActive">


        <div class="row margin-top-16">
          <div class="col-md-12 col-lg-3 label">{{'bikeshop.message_templates.whatsapp.controls.whatsapp_header_type' |
            translate}}:</div>
          <div class="col-md-4 col-lg-3">
            <p-dropdown [options]="whatsappHeaderTypeOptions"
              [(ngModel)]="messageTemplate.WhatsappHeaderType"></p-dropdown>
          </div>
        </div>

        <div class="row margin-top-16" *ngIf="messageTemplate.WhatsappHeaderType == 'TEXT'">
          <div class="col-md-12 col-lg-3 label"
            [ngClass]="{'red': messageTemplate.WhatsappHeaderText == null || messageTemplate.WhatsappHeaderText == undefined || messageTemplate.WhatsappHeaderText.length === 0}">
            {{'bikeshop.message_templates.whatsapp.controls.whatsapp_header_text' | translate}}:</div>
          <div class="col-md-12 col-lg-4">
            <div class="p-inputgroup">
              <input type="text" pInputText maxlength="60" [(ngModel)]="messageTemplate.WhatsappHeaderText" />
              <span class="p-inputgroup-addon" style="width: 60px;font-size: 13px;margin-left: 16px;">
                {{messageTemplate.WhatsappHeaderText !== null && messageTemplate.WhatsappHeaderText !== undefined ?
                messageTemplate.WhatsappHeaderText.length : 0}}/{{60}}</span>
            </div>
          </div>
        </div>

        <div class="row margin-top-16" *ngIf="messageTemplate.WhatsappHeaderType == 'IMAGE'">
          <div class="col-md-12 col-lg-3 label" [ngClass]="{'red': !messageTemplate.WhatsappHeaderImage}">
            {{'bikeshop.message_templates.whatsapp.controls.whatsapp_header_image' | translate}}:</div>
          <div class="col-md-12 col-lg-3 flex">
            <button pButton class="full-width alternate" (click)="fileUpload.click()"
              label="{{'bikeshop.message_templates.whatsapp.controls.whatsapp_header_image_button' | translate}}"></button>
            <input #fileUpload type="file" multiple accept="image/*;" style="display: none"
              (change)="uploadWhatsAppHeaderImage($event)">
          </div>
          <div class="col-md-12 col-lg-3">

            <div class="row" *ngIf="messageTemplate.WhatsappHeaderImage">
              <div class="col-md-12 margin-bottom-16">
                <div class="primary-image" [ngClass]="{ 'primary-image-loading' : uploadingWhatsAppHeaderImage}"
                  [ngStyle]="{'background-image': 'url('+messageTemplate.WhatsappHeaderImage+'), linear-gradient(0deg, white 0%, white 100%)'}">
                </div>
                <div class="primary-image-overlay" *ngIf="uploadingWhatsAppHeaderImage">
                  <p-progressSpinner [style]="{ width: '30px', height: '30px' }"
                    animationDuration=".5s"></p-progressSpinner>
                </div>
              </div>
            </div>

          </div>
        </div>


        <div class="row margin-top-16">
          <div class="col-md-12 col-lg-3 label"
            [ngClass]="{'red': messageTemplate.WhatsappBodyText == null || messageTemplate.WhatsappBodyText == undefined || messageTemplate.WhatsappBodyText.length === 0}">
            {{'bikeshop.message_templates.whatsapp.controls.whatsapp_body_text' | translate}}:</div>
          <div class="col-md-12 col-lg-9">
            <div class="p-inputgroup">
              <textarea rows="4" maxlength="1024" autoResize="true"
                [(ngModel)]="messageTemplate.WhatsappBodyText"></textarea>
              <span class="p-inputgroup-addon" style="width: 60px;font-size: 13px;margin-left: 16px;">
                {{messageTemplate.WhatsappBodyText !== null && messageTemplate.WhatsappBodyText !== undefined ?
                messageTemplate.WhatsappBodyText.length : 0}}/{{1024}}</span>
            </div>
          </div>
        </div>

        <div class="row margin-top-16">
          <div class="col-md-12 col-lg-3 label">{{'bikeshop.message_templates.available_merge_tags' | translate}}:</div>
          <div class="col-md-12 col-lg-9 merge-tag-container">
            <div *ngFor="let tag of listMergeTags()">
              <div>{{tag.value}}</div>
            </div>
          </div>
        </div>

        <div class="row margin-top-16">
          <div class="col-md-12 col-lg-3 label">{{'bikeshop.message_templates.whatsapp.controls.whatsapp_footer_text' |
            translate}}:</div>
          <div class="col-md-12 col-lg-4">
            <div class="p-inputgroup">
              <input type="text" pInputText maxlength="60" [(ngModel)]="messageTemplate.WhatsappFooterText" />
              <span class="p-inputgroup-addon" style="width: 60px;font-size: 13px;margin-left: 16px;">
                {{messageTemplate.WhatsappFooterText !== null && messageTemplate.WhatsappFooterText !== undefined ?
                messageTemplate.WhatsappFooterText.length : 0}}/{{60}}</span>
            </div>
          </div>
        </div>


        <div class="row margin-top-16"
          *ngIf="eventWhatsappCallToActionButtons && eventWhatsappCallToActionButtons.length > 0">
          <div class="col-md-12 col-lg-3 label">{{ 'bikeshop.message_templates.whatsapp.controls.button_option.title' |
            translate }}</div>
          <div class="col-md-12 col-lg-9">
            <div *ngFor="let button of eventWhatsappCallToActionButtons">
              <div class="row">
                <div class="col-md-3 label">
                  <p-checkbox [(ngModel)]="button.selected" [binary]="true"></p-checkbox><span
                    style="margin-left: 8px;">{{button.ButtonLabel}}</span>
                </div>
                <!-- <div class="col-md-6 label" *ngIf="button.selected">
                  <div class="p-inputgroup">
                  <input type="text" pInputText maxlength="25" [(ngModel)]="button.customLabel" placeholder="{{ 'bikeshop.message_templates.whatsapp.controls.button_option.custom_button_title' | translate }}" />
                  <span class="p-inputgroup-addon" style="width: 60px;font-size: 13px;margin-left: 16px;">
                    {{button.customLabel !== null && button.customLabel !== undefined ?
                      button.customLabel.length : 0}}/{{25}}</span>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="margin-top-8"><small class="bold red">{{
                'bikeshop.message_templates.whatsapp.controls.button_option.description' | translate }}</small></div>
          </div>
        </div>


        <div class="row margin-top-16">
          <div class="col-md-12 col-lg-3 label">{{'bikeshop.message_templates.whatsapp.status' | translate}}:</div>
          <div class="col-md-12 col-lg-9 label">
            <div class="status" [ngClass]="{
              'not-syncd': !messageTemplate.WAStatus, 
              'approved': messageTemplate.WAStatus === 'APPROVED',
              'pending': messageTemplate.WAStatus === 'PENDING',
              'rejected': messageTemplate.WAStatus === 'REJECTED',
              'pending-deletion': messageTemplate.WAStatus === 'PENDING_DELETION',
            }">
              {{messageTemplate.WAStatus ? messageTemplate.WAStatus :
              ('bikeshop.message_templates.whatsapp.status_not_synced' | translate)}}
            </div>
          </div>
        </div>

        <div class="row margin-top-16" *ngIf="messageTemplate.WAQuality">
          <div class="col-md-12 col-lg-3 label">{{'bikeshop.message_templates.whatsapp.quality_score' | translate}}:
          </div>
          <div class="col-md-12 col-lg-9 label">
            {{messageTemplate.WAQuality}}
          </div>
        </div>

        <div class="row margin-top-16"
          *ngIf="messageTemplate.WARejectReason && messageTemplate.WARejectReason !== 'NONE'">
          <div class="col-md-12 col-lg-3 label">{{'bikeshop.message_templates.whatsapp.sync_error' | translate}}:</div>
          <div class="col-md-12 col-lg-9 label">
            {{messageTemplate.WARejectReason && messageTemplate.WARejectReason.error &&
            messageTemplate.WARejectReason.error.error_user_msg ? messageTemplate.WARejectReason.error.error_user_msg :
            messageTemplate.WARejectReason && messageTemplate.WARejectReason.error &&
            messageTemplate.WARejectReason.error.message ? messageTemplate.WARejectReason.error.message :
            getObjectString(messageTemplate.WARejectReason)}}
          </div>
        </div>


      </div>

    </div>


    <div class="info-container" *ngIf="!hideNonWhatsapp">
      <div class="category-header">{{'bikeshop.message_templates.sms_header' | translate}}</div>


      <div class="row">
        <div class="col-md-6 col-lg-3 label">{{'bikeshop.message_templates.short_message_active' | translate}}:</div>
        <div class="col-md-6 col-lg-9">
          <p-inputSwitch [(ngModel)]="messageTemplate.ShortMessageActive"
            [disabled]="messageTemplate.EventTag === 'rentals.waiversigned'"></p-inputSwitch>
        </div>
      </div>
      <div class="row margin-top-16">
        <div class="col-md-12 col-lg-3 label">{{ 'bikeshop.message_templates.short_message_template' | translate}}:
        </div>
        <div class="col-md-12 col-lg-9">
          <input type="text" pInputText [(ngModel)]="messageTemplate.ShortMessage_Template"
            [disabled]="messageTemplate.EventTag === 'rentals.waiversigned'" />
          <div class="char-limit">
            {{
            160 - (messageTemplate.ShortMessage_Template !== null &&
            messageTemplate.ShortMessage_Template !== undefined ? messageTemplate.ShortMessage_Template.length : 0) - 30
            -
            partner.Name.length
            }} Left
          </div>
          <!--<small class="char-limit">
        {{
        partner.Name + ': ' + messageTemplate.ShortMessage_Template + ' https://tinyurl.com/xxxxxxxx'
        }}
      </small>-->
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-3"></div>
        <div class="col-md-12 col-lg-9">
          <small>
            *{{
            'bikeshop.message_templates.short_message_information' | translate
            }}
          </small>
        </div>
      </div>


      <div class="row margin-top-16">
        <div class="col-md-12 col-lg-3 label">{{'bikeshop.message_templates.available_merge_tags' | translate}}:</div>
        <div class="col-md-12 col-lg-9 merge-tag-container">
          <div *ngFor="let tag of listMergeTags()">
            <div>{{tag.value}}</div>
          </div>
        </div>
      </div>

    </div>


    <div class="info-container" *ngIf="!hideNonWhatsapp">
      <div class="category-header">{{'bikeshop.message_templates.email_header' | translate}}</div>
      <div class="row margin-top-16">
        <div class="col-md-6 col-lg-3 label">{{'bikeshop.message_templates.active' | translate}}:</div>
        <div class="col-md-6 col-lg-9">
          <p-inputSwitch [(ngModel)]="messageTemplate.IsActive"></p-inputSwitch>
        </div>
      </div>
      <div class="row margin-top-16">
        <div class="col-md-12 col-lg-3 label">{{ 'bikeshop.message_templates.email_subject' | translate}}:</div>
        <div class="col-md-12 col-lg-9">
          <input type="text" pInputText maxlength="100" [(ngModel)]="messageTemplate.EmailTemplateSubject" />
        </div>
      </div>
      <div class="row margin-top-16">
        <div class="col-md-12">
          <!-- <angular-editor [(ngModel)]="messageTemplate.Template" [config]="editorConfig"></angular-editor> -->
          <email-editor [appearance]="appearance" [options]="options"
            [minHeight]="(screenHeight - 530 < 530 ? 530 : screenHeight - 530)+'px'"></email-editor>
        </div>
      </div>
      <div style="margin-top: -50px;margin-left: 8px;" *ngIf="classicTemplate && !saving">
        <button pButton class="accent" (click)="resetTemplate()"
          label="{{'bikeshop.message_templates.use_new_template_builder' | translate}}" [disabled]="saving"></button>
      </div>
      <div class="row margin-top-16" *ngIf="filteredMessageTemplates.length > 0">
        <div class="col-md-6 col-lg-3 label">{{'bikeshop.message_templates.import_template_from' | translate}}:</div>
        <div class="col-md-6 col-lg-3">
          <p-dropdown [options]="filteredMessageTemplates" [(ngModel)]="templateImport"
            placeholder="Select a template to import"></p-dropdown>
        </div>
        <div class="col-md-6 col-lg-3">
          <button pButton class="ui-button-raised alternate" label="{{'general.import' | translate}}"
            [disabled]="templateImport === null || templateImport.length===0" (click)="importDesign()"></button>
        </div>
      </div>

    </div>

    <div class="floating-footer">
      <div class="row">
        <div class="col-md-3">
          <button pButton class="full-width alternate" (click)="cancel()" label="{{'general.cancel' | translate}}"
            [disabled]="saving"></button>
        </div>
        <div class="col-md-6"></div>
        <div class="col-md-3">
          <button pButton *ngIf="!saving" class="full-width" (click)="saveTemplate()"
            label="{{'bikeshop.message_templates.save_template' | translate}}" [disabled]="saving"></button>
          <div *ngIf="saving" style="display: flex;justify-content: center;">
            <p-progressSpinner [style]="{ width: '40px', height: '40px' }" animationDuration=".5s">
            </p-progressSpinner>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
<p-confirmDialog key="add_edit_message_templates"></p-confirmDialog>